export const getQueryStringValue = (key: string) => {
    return decodeURIComponent(
        location.search.replace(
            new RegExp(
                '^(?:.*[&\\?]' +
                    encodeURIComponent(key).replace(/[.+*]/g, '\\$&') +
                    '(?:\\=([^&]*))?)?.*$',
                'i'
            ),
            '$1'
        )
    );
};

const getCoordinatorIP = () => {
    let coordinatorIP = getQueryStringValue('ws');
    if (coordinatorIP == '') {
        if (location.host.indexOf(':') !== -1) {
            coordinatorIP = location.host.split(':')[0];
        } else {
            coordinatorIP = location.host;
        }
    }
    return coordinatorIP;
};

const getCoordinatorPort = () => {
    return getQueryStringValue('port') || '9001';
};

const getCoordinatorUrlScheme = () => {
    return location.protocol === 'https:' || process.env.NODE_ENV === 'development'
        ? 'wss'
        : 'ws';
};

export const combineCoordinatorUrl = () => {
    const token = getQueryStringValue('token');
    const urlScheme = getCoordinatorUrlScheme();
    const address = getCoordinatorIP();
    const port = getCoordinatorPort();
    const accessToken = localStorage.getItem('authAccessToken');

    const tokenPart = token
        ? `?token=${token}${accessToken ? '&accessToken=' + accessToken : ''}`
        : '';

    return `${urlScheme}://${address}:${port}${tokenPart}`;
};

export const getVenueEnv = () => {
    if (process.env.NODE_ENV === 'development') {
        return 'local';
    }

    const env = new URLSearchParams(window.location.search).get('ws')?.split('.')[1];

    switch (env) {
        case 'dev':
            return 'development';
        case 'stage':
            return 'staging';
        case 'prod':
            return 'production';
        default:
            return '';
    }
};

export const persistUrlData = () => {
    localStorage.setItem('urlData', window.location.search + window.location.hash);
};

export const restoreUrlData = () => {
    const urlData = localStorage.getItem('urlData');
    history.replaceState(null, '', urlData);
};

const s4 = () => {
    return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
};

export const uniqueKey = () => {
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
};
